export const MODE_VIEW = 'View';
export const MODE_ADD = 'Add';
export const MODE_EDIT = 'Edit';
